import type { SelectedTalent } from "../shared/types";

export const LIST_ORDER_SORT_BY = "all-listOrder-asc";

/**
 * Returns talent ids in display/save order.
 * Uses talentOrder when present (drops stale ids, appends talent keys missing from order).
 * Legacy lists without talentOrder fall back to Object.keys(talent).
 */
export function orderedTalentIds(
    talent?: SelectedTalent,
    talentOrder?: string[],
): string[] {
    const keys = Object.keys(talent ?? {});
    if (talentOrder === undefined || talentOrder.length === 0) {
        return keys;
    }

    const remaining = new Set(keys);
    const ordered: string[] = [];

    for (const id of talentOrder) {
        if (remaining.has(id)) {
            ordered.push(id);
            remaining.delete(id);
        }
    }

    for (const id of keys) {
        if (remaining.has(id)) {
            ordered.push(id);
        }
    }

    return ordered;
}
